import { useQuery } from '@tanstack/react-query';

import { DeclarationCustomsType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
}

interface DeclarationTypeResponse {
  declarationType: string;
  sentTo?: DeclarationCustomsType;
}

export const useGetDeclarationTypeForBatch = ({ batchId }: HookProps) =>
  useQuery({
    queryKey: ['declaration-type', batchId],
    queryFn: async (): Promise<DeclarationTypeResponse> => {
      try {
        const { data } = await request({
          path: `declarations/retrieve-declaration-type`,
          method: 'POST',
          authenticate: true,
          dataObject: { batchId },
        });

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration type');
      }
    },
    placeholderData: { declarationType: '' },
  });
